import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=42c379a4&"
import script from "./Recovery.vue?vue&type=script&lang=ts&"
export * from "./Recovery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports